/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/

/********************** DON'T ADD ANYTHING TO THIS FILE  ********************/

/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/
/********************** IMPORTANT  ********************/

// Just using this type here to prevent typos:
export type TagName =
  | 'base'
  | 'wf-comment'
  | 'wf-custom-code'
  | 'head'
  | 'html'
  | 'link'
  | 'script'
  | 'style'
  | 'title'
  | 'meta'
  | 'a'
  | 'blockquote'
  | 'body'
  | 'br'
  | 'div'
  | 'em'
  | 'figcaption'
  | 'figure'
  | 'form'
  | 'iframe'
  | 'img'
  | 'input'
  | 'label'
  | 'li'
  | 'p'
  | 'select'
  | 'span'
  | 'strong'
  | 'textarea'
  | 'fieldset'
  | 'sup'
  | 'sub'
  | 'code'
  | 'pre';

/**
 * A signal that a Node Type can have a configurable HTML Tag.
 *
 * This means you should read the tag from `node.data.tag`.
 */
export const GET_FROM_DATA: {
  getTagFromData: true;
} = {getTagFromData: true};

/**
 * A mapping of Node Type to HTML Tag name.
 *
 * If the mapping is a string, you can use it as a tag name,
 * otherwise, it means you should read the tag from `node.data.tag`.
 */
export const TAG_BY_NODE_TYPE: {
  [key: string]: TagName | typeof GET_FROM_DATA;
} = {
  Block: GET_FROM_DATA,
  Base: 'base',
  Comment: 'wf-comment',
  CustomCode: 'wf-custom-code',
  Head: 'head',
  Document: 'html',
  Resource: 'link',
  Script: 'script',
  Style: 'style',
  Title: 'title',
  Meta: 'meta',

  Heading: GET_FROM_DATA,

  SearchForm: 'form',
  SearchInput: 'input',
  SearchButton: 'input',
  SearchResultEmpty: GET_FROM_DATA,
  SearchResultWrapper: GET_FROM_DATA,
  SearchResultList: GET_FROM_DATA,
  SearchResultItem: GET_FROM_DATA,

  SliderArrow: 'div',
  SliderMask: 'div',
  SliderNav: 'div',
  SliderSlide: GET_FROM_DATA,
  SliderWrapper: 'div',

  TabsContent: GET_FROM_DATA,
  TabsLink: 'a',
  TabsMenu: GET_FROM_DATA,
  TabsPane: GET_FROM_DATA,
  TabsWrapper: 'div',

  Icon: 'div',

  NavbarBrand: 'a',
  NavbarButton: GET_FROM_DATA,
  NavbarContainer: GET_FROM_DATA,
  NavbarLink: 'a',
  NavbarMenu: GET_FROM_DATA,
  NavbarWrapper: GET_FROM_DATA,

  DropdownLink: 'a',
  DropdownList: GET_FROM_DATA,
  DropdownToggle: GET_FROM_DATA,
  DropdownWrapper: GET_FROM_DATA,

  Blockquote: 'blockquote',
  Emphasized: 'em',
  Figcaption: 'figcaption',
  Figure: 'figure',
  Iframe: 'iframe',
  LineBreak: 'br',
  Link: 'a',
  List: GET_FROM_DATA,
  ListItem: 'li',
  Paragraph: 'p',
  RichText: GET_FROM_DATA,
  Span: 'span',
  Strong: 'strong',

  Body: 'body',

  Container: GET_FROM_DATA,
  Row: GET_FROM_DATA,
  Column: GET_FROM_DATA,
  Section: GET_FROM_DATA,

  Symbol: 'div',

  DynamoWrapper: GET_FROM_DATA,
  DynamoList: GET_FROM_DATA,
  DynamoItem: 'div',
  DynamoEmpty: GET_FROM_DATA,

  CommerceAddToCartForm: 'form',
  CommerceAddToCartButton: 'input',
  CommerceAddToCartWrapper: GET_FROM_DATA,
  CommerceAddToCartQuantityInput: 'input',
  CommerceAddToCartOptionList: 'fieldset',
  CommerceAddToCartOption: 'fieldset',
  CommerceAddToCartOptionLabel: 'label',
  CommerceAddToCartOptionSelect: 'select',
  CommerceAddToCartError: GET_FROM_DATA,
  CommerceAddToCartErrorText: GET_FROM_DATA,
  CommerceAddToCartOutOfStock: GET_FROM_DATA,

  CommerceCartWrapper: GET_FROM_DATA,
  CommerceCartOpenLink: 'a',
  CommerceCartOpenLinkCount: 'div',
  CommerceCartOpenLinkImage: 'img',
  CommerceCartContainerWrapper: 'div',
  CommerceCartContainer: 'div',
  CommerceCartHeader: 'div',
  CommerceCartHeading: GET_FROM_DATA,
  CommerceCartFormWrapper: 'div',
  CommerceCartForm: 'div',
  CommerceCartEmptyState: 'div',
  CommerceCartErrorState: 'div',
  CommerceCartList: GET_FROM_DATA,
  CommerceCartFooter: 'div',
  CommerceCartLineItem: 'div',
  CommerceCartCheckoutButton: 'a',
  CommerceCartItem: 'div',
  CommerceCartItemImage: 'img',
  CommerceCartItemInfo: 'div',
  CommerceCartProductName: GET_FROM_DATA,
  CommerceCartCloseLink: 'a',
  CommerceCartRemoveLink: 'a',
  CommerceCartOrderValue: GET_FROM_DATA,
  CommerceCartErrorText: GET_FROM_DATA,

  FormBlockLabel: 'label',
  FormButton: 'input',
  FormCheckboxInput: 'input',
  FormCheckboxWrapper: 'div',
  FormErrorMessage: 'div',
  FormForm: 'form',
  FormInlineLabel: 'label',
  FormRadioInput: 'input',
  FormRadioWrapper: 'div',
  FormReCaptcha: 'div',
  FormSelect: 'select',
  FormSuccessMessage: 'div',
  FormTextarea: 'textarea',
  FormTextInput: 'input',
  FormWrapper: 'div',
  FormFileUploadWrapper: 'div',
  FormFileUploadDefault: 'div',
  FormFileUploadUploading: 'div',
  FormFileUploadUploadingBtn: 'div',
  FormFileUploadSuccess: 'div',
  FormFileUploadFile: 'div',
  FormFileUploadFileName: 'div',
  FormFileUploadRemoveLink: 'div',
  FormFileUploadError: 'div',
  FormFileUploadErrorMsg: 'div',
  FormFileUploadInput: 'input',
  FormFileUploadLabel: 'label',
  FormFileUploadInfo: 'div',

  Image: 'img',
  BackgroundVideoWrapper: GET_FROM_DATA,
  HtmlEmbed: 'div',
  Video: 'div',
  LightboxWrapper: 'a',
  Facebook: 'div',
  GooglePlus: 'div',
  MapWidget: 'div',
  Twitter: 'div',
  Superscript: 'sup',
  Subscript: 'sub',
  InlineCode: 'code',
  CodeBlock: 'pre',
};
